const LOCALE_BY_LANGUAGE: Record<string, string> = {
  cs: 'cs-CZ',
  sk: 'sk-SK',
};

function getIntlLocale(locale: string) {
  const candidate = LOCALE_BY_LANGUAGE[locale] ?? locale.replaceAll('_', '-');

  try {
    return Intl.getCanonicalLocales(candidate)[0] ?? 'en';
  } catch {
    return 'en';
  }
}

export function formatTourPrice(value: number | undefined, locale: string) {
  if (typeof value !== 'number') return '-';

  return new Intl.NumberFormat(getIntlLocale(locale), {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value);
}
